import { render, staticRenderFns } from "./ReportElementsComponent.vue?vue&type=template&id=d20854f6"
import script from "./ReportElementsComponent.vue?vue&type=script&lang=js"
export * from "./ReportElementsComponent.vue?vue&type=script&lang=js"
import style0 from "./ReportElementsComponent.vue?vue&type=style&index=0&id=d20854f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports